import { Injectable } from '@angular/core';
import { Logger } from '../logger.service';
import { HttpService } from './http.service';
import { environment } from '@env/environment';
import { PayoutConfirmPayload, PayoutInitPayload, PayoutSendPayload } from '../models/payout.model';
import { STPData } from './spei.service';
import { IpApiService } from './ip-api/ip-api.service';

const log = new Logger('wallet-service');

@Injectable({
  providedIn: 'root',
})
export class PayoutService {
  constructor(private httpS: HttpService, private ipS: IpApiService) {}

  async initPayout(init: PayoutInitPayload) {
    try {
      const url = environment.api.payout.url;
      const response = await this.httpS.post(`${url}/init`, init);
      log.info(response);
      const trasnfered = response as any;
      return trasnfered;
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async sendUpo(init: PayoutSendPayload) {
    try {
      const url = environment.api.payout.url;
      const response = await this.httpS.post(`${url}/send`, init);
      log.info(response);
      const trasnfered = response as any;
      return trasnfered;
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async confirm(init: PayoutConfirmPayload) {
    try {
      const url = environment.api.payout.url;
      const response = await this.httpS.post(`${url}/confirm`, init);
      log.info(response);
      const trasnfered = response as any;
      return trasnfered;
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async saveUpo(stp: Pick<STPData, 'apmData' | 'billingAddress'>) {
    try {
      const url = environment.api.payout.url;
      const response = await this.httpS.post(`${url}/saveUPO`, { stp });
      log.info(response);
      const trasnfered = response as any;
      return trasnfered;
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async deleteUpo(stpId: string) {
    try {
      const url = environment.api.payout.url;
      const response = await this.httpS.post(`${url}/deleteUPO`, { stpId });
      log.info(response);
      const trasnfered = response as any;
      return trasnfered;
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async addPayout(stpId: string, amount: number) {
    try {
      const dataIp = await this.ipS.getIp();
      if (dataIp) {
        const url = environment.api.payout.url;
        const response = await this.httpS.post(`${url}/sendPayout`, { stpId, amount, ipAddress: dataIp.query });
        log.info(response);
        const trasnfered = response as any;
        return trasnfered;
      }
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async reviverPayout(transactionId: string) {
    try {
      const url = environment.api.payout.url;
      const response = await this.httpS.post(`${url}/reviverPayout`, { transactionId });
      log.info(response);
      const trasnfered = response as any;
      return trasnfered;
    } catch (error) {
      log.error(error);
    }
    return null;
  }
}
